import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const PaymentCheck = () => {
    const [searchParams] = useSearchParams();
    const redirectTo = searchParams.get("redirectTo"); 

    useEffect(() => {
        window.top.location.href = redirectTo;
    },[redirectTo])

    return  <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="spinner-border text-primary" role="status">
        </div>
    </div>
};
export default PaymentCheck;
